import { useEffect, useRef, useState } from "react";
import dropwDownArrow from "../assets/svg/dropdown-arrow.svg";

const CustomDropDownSelect = ({
  options = [],
  value,
  onChange,
  selectDropdown = "up",
  containerStyle = "relative",
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const selected = options.find((o) => o.value === value) || options[0] || null;

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={ref} className={`${containerStyle}`}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="w-full flex items-center justify-between gap-2 px-2 py-2 h-[40px] rounded-md border bg-white"
      >
        <div className="flex items-center gap-2">
          {selected?.icon && (
            <img src={selected.icon} alt="" className="w-4 h-4" />
          )}
          <span className="text-sm whitespace-nowrap overflow-hidden text-ellipsis max-w-[160px]">
            {selected?.label || "Select"}
          </span>
        </div>

        <img
          src={dropwDownArrow}
          alt="dropdown arrow"
          className={`w-4 h-4 opacity-70 transition-transform ${
            open && selectDropdown == "up" ? "rotate-180" : ""
          }`}
        />
      </button>

      {open && options.length > 0 && (
        <div
          className={`absolute z-50 ${selectDropdown == "up" ? "bottom-full" : "top-full"} mb-1 w-full bg-white border rounded-md shadow`}
        >
          {options.map((opt) => (
            <div
              key={opt.value}
              onClick={() => {
                onChange(opt.value);
                setOpen(false);
              }}
              className={`flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-100 ${
                opt.value === value ? "bg-gray-100" : ""
              }`}
            >
              {opt.icon && <img src={opt.icon} alt="" className="w-4 h-4" />}
              <span>{opt.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropDownSelect;
